import { useState } from "react";

const FAQ = ({ ...props }) => {
    const { 
        heading,
        description,
        faqs,
    } = props
    
    console.log({props});
    
  return <div className="faq lg:tw-p-25 tw-p-8">
    <div className="tw-max-w-[700px]">
        <h2 className="tw-text-3.5xl tw-font-roboto tw-font-bold tw-mb-4">{heading}</h2>
        <p className="tw-text-md tw-font-roboto tw-mb-8" dangerouslySetInnerHTML={{ __html: description }}/>
        <div className="tw-flex tw-flex-col tw-gap-4">
            {faqs.map((faq, i) => <FAQItem {...faq?.fields} key={i}/>)}
        </div>
    </div>
  </div>;
};

const FAQItem = ({ question, answer }) => {
    const [isOpen, setIsOpen] = useState(false);
    return <div className="tw-bg-grey-500">
        <button className="tw-flex tw-justify-between tw-items-center tw-gap-3 tw-w-full tw-p-4" onClick={() => setIsOpen(!isOpen)}>
            <h3 className="tw-text-2xl tw-font-roboto tw-text-left tw-font-bold tw-capitalize">{question}</h3>
            <svg width="48" height="48" className={isOpen ? "tw-transform tw-rotate-180" : ""} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M24 20L18 26L19.41 27.41L24 22.83L28.59 27.41L30 26L24 20Z" fill="black" fillOpacity="0.54"/>
            </svg>                  
        </button>
        {!!isOpen && <div className="faq-richtext tw-text-xl tw-font-roboto tw-pb-4 tw-pr-4 tw-pl-12" dangerouslySetInnerHTML={{ __html: answer }}/>}
    </div>
}
export default FAQ;